import type { VariantProps } from 'class-variance-authority';
import type { PropsWithChildren } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/utils/cn';

const notificationBadgeVariants = cva(
  'flex shrink-0 items-center justify-center rounded-full bg-primary-1 text-[0.625rem] font-medium leading-4 text-white',
  {
    variants: {
      variant: {
        compact: 'size-4.5',
        bordered: 'h-5 min-w-5 overflow-hidden border-2 border-c900',
      },
    },
    defaultVariants: {
      variant: 'compact',
    },
  },
);

interface NotificationBadgeProps extends PropsWithChildren, VariantProps<typeof notificationBadgeVariants> {
  className?: string;
}

export const NotificationBadge = ({ className, children, variant }: NotificationBadgeProps) => {
  return (
    <span className={cn(notificationBadgeVariants({ variant }), className)}>
      {children}
    </span>
  );
};
